import { Typography } from "@mui/material";

import SquareChip from "@/components/elements/Chips/SquareChip";
import ListCard from "@/components/Luna/features/ListCard/ListCard";
import useLesson from "@/contexts/useLesson";
import { Problem } from "@/types";
import { htmlContentStyles } from "@/utils/htmlContentStyle";
import { renderMathInHtml } from "@/utils/mathRenderer";
import getQuestionTypeLabel from "@/utils/problems/getQuestionTypeLabel";

interface Props {
  problem: Problem;
  index: number;
  onApprove: (index: number) => void;
  onRegenerate: (index: number) => void;
  onDelete: (index: number) => void;
  onOpenModal: (index: number) => void;
  onEdit: (index: number) => void;
}

const ProblemItem = ({
  problem,
  index,
  onApprove,
  onRegenerate,
  onDelete,
  onOpenModal,
  onEdit,
}: Props) => {
  const { lessonResourceState } = useLesson();
  const isRead = lessonResourceState?.readItems?.includes(problem.id);

  return (
    <ListCard
      title={`Problem ${index + 1}`}
      index={index}
      isApproved={problem.isApproved}
      onDelete={onDelete}
      onApprove={onApprove}
      onRegenerate={onRegenerate}
      isGenerated={problem.isGenerated}
      onEdit={() => onEdit(index)}
      onOpenModal={() => onOpenModal(index)}
      status={
        problem.isApproved
          ? problem.studentAnswer
            ? "complete"
            : "sent"
          : "pending"
      }
      id={problem.id}
      isRead={isRead}
      appearance="example"
      viewMoreLabel="View problem"
    >
      <SquareChip
        label={getQuestionTypeLabel(problem.type)}
        sx={{
          mb: 1,
          py: 0,
          px: 0.5,
          borderRadius: 1,
          border: "none",
          backgroundColor: "background.paper",
          color: "text.primary",
          fontWeight: 500,
          textTransform: "none",
          letterSpacing: 0,
        }}
      />
      <Typography
        component="div"
        variant="text13L"
        dangerouslySetInnerHTML={{
          __html: renderMathInHtml(problem.question, problem.formatVersion),
        }}
        sx={{
          ...htmlContentStyles,
          fontSize: "13px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onOpenModal(index);
        }}
      />
    </ListCard>
  );
};

export default ProblemItem;
